import { render } from "./CancelAppointmentDialog.vue?vue&type=template&id=67acd917&scoped=true"
import script from "./CancelAppointmentDialog.vue?vue&type=script&lang=js"
export * from "./CancelAppointmentDialog.vue?vue&type=script&lang=js"

import "./CancelAppointmentDialog.vue?vue&type=style&index=0&id=67acd917&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67acd917"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn,QForm,QSelect,QCheckbox,QCardActions,QSpace});qInstall(script, 'directives', {ClosePopup});
